var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { color } from '../../constants';
import { MaxWidth } from '../../layout';
var Nav = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  ", "\n"], ["\n  background-color: ", ";\n  width: 100%;\n  ",
    "\n"])), color.pureWhite, function (props) {
    return props.hasBottomBorder !== undefined && props.hasBottomBorder
        ? "\n    border-width: 0px 0px 1px;\n    border-color: initial;\n    border-bottom: 1px solid;\n    border-image: linear-gradient(270deg, rgb(247, 249, 250) 0%, rgb(207, 211, 214) 50%, rgb(247, 249, 250) 100%) 1 / 1 / 0 stretch;\n    "
        : {};
});
export var TertiaryNav = function (_a) {
    var className = _a.className, children = _a.children, hasBottomBorder = _a.hasBottomBorder;
    return (React.createElement(Nav, { hasBottomBorder: hasBottomBorder, className: className },
        React.createElement(MaxWidth, null, children)));
};
var templateObject_1;
//# sourceMappingURL=index.js.map